(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TestPlanMonitoringController', TestPlanMonitoringController);

    TestPlanMonitoringController.$inject = ['$stateParams', 'TestPlan', '$translate'];

    function TestPlanMonitoringController($stateParams, TestPlan, $translate) {
        var vm = this;

        vm.status = $stateParams.status || 'TODO';
        vm.plans = [];
        vm.selectedPlan = null;
        vm.scenarioDefinitionsByKey = {};
        vm.errorMessage = null;
        vm.planStats = null;

        vm.refresh = refresh;
        vm.showPlan = showPlan;
        vm.changeStatus = changeStatus;
        vm.hidePlan = hidePlan;
        vm.deletePlan = deletePlan;
        vm.deleting = false;
        vm.getScenarioDomainTitle = getScenarioDomainTitle;
        vm.getScenarioTitle = getScenarioTitle;
        vm.getScenarioAnswerLabel = getScenarioAnswerLabel;
        vm.getScenarioResponseTypeLabel = getScenarioResponseTypeLabel;
        vm.getOverallStatusLabel = getOverallStatusLabel;
        vm.getResultProgressLabel = getResultProgressLabel;
        vm.getAttachmentCount = getAttachmentCount;

        activate();

        function activate() {
            refresh();
        }

        function refresh() {
            resetSelectedPlan();
            vm.errorMessage = null;

            TestPlan.query({ status: vm.status }, function(result) {
                vm.plans = result || [];
                if (vm.plans.length > 0) {
                    showPlan(vm.plans[0]);
                }
            }, function(response) {
                vm.errorMessage = resolveErrorMessage(response, 'Impossible de charger la liste des plans de test.');
            });
        }

        function showPlan(planSummary) {
            if (!planSummary || !planSummary.storageKey) {
                resetSelectedPlan();
                return;
            }

            vm.errorMessage = null;
            TestPlan.detail({ storageKey: planSummary.storageKey, status: vm.status }, function(result) {
                vm.selectedPlan = result;
                indexScenarioDefinitions();
                buildPlanStats();
            }, function(response) {
                vm.errorMessage = resolveErrorMessage(response, 'Impossible de charger le détail du plan de test.');
            });
        }

        function changeStatus(status) {
            vm.status = status;
            refresh();
        }

        function hidePlan() {
            if (!vm.selectedPlan || !vm.selectedPlan.summary || !vm.selectedPlan.summary.storageKey) {
                return;
            }
            if (!window.confirm('Masquer ce plan de test de la liste ?')) {
                return;
            }

            TestPlan.hide({ storageKey: vm.selectedPlan.summary.storageKey, status: vm.status }, function() {
                resetSelectedPlan();
                refresh();
            }, function(response) {
                vm.errorMessage = resolveErrorMessage(response, 'Impossible de masquer le plan de test.');
            });
        }


        function deletePlan() {
            if (vm.deleting || !vm.selectedPlan || !vm.selectedPlan.summary) {
                return;
            }
            var plan = vm.selectedPlan.summary;
            if (!window.confirm($translate.instant('testPlan.monitoring.deleteConfirmation', { title: plan.title }))) {
                return;
            }

            vm.deleting = true;
            vm.errorMessage = null;
            TestPlan.deletePlan({ storageKey: plan.storageKey, status: vm.status }, function() {
                vm.deleting = false;
                refresh();
            }, function(response) {
                vm.deleting = false;
                vm.errorMessage = resolveErrorMessage(response, $translate.instant('testPlan.monitoring.deleteError'));
            });
        }

        function resetSelectedPlan() {
            vm.selectedPlan = null;
            vm.scenarioDefinitionsByKey = {};
            vm.planStats = null;
        }

        function indexScenarioDefinitions() {
            vm.scenarioDefinitionsByKey = {};
            if (!vm.selectedPlan || !vm.selectedPlan.plan || !vm.selectedPlan.plan.domains) {
                return;
            }

            vm.selectedPlan.plan.domains.forEach(function(domain) {
                if (!domain || !domain.scenarios) {
                    return;
                }
                domain.scenarios.forEach(function(scenario) {
                    vm.scenarioDefinitionsByKey[buildScenarioKey(domain.domainId, scenario.scenarioId)] = {
                        domainTitle: domain.title,
                        scenarioTitle: scenario.title,
                        responseType: scenario.responseType || 'STATUS'
                    };
                });
            });
        }

        function buildPlanStats() {
            var results = vm.selectedPlan && vm.selectedPlan.results ? vm.selectedPlan.results : [];
            var stats = {
                assignedCount: results.length,
                completedCount: 0,
                inProgressCount: 0,
                notStartedCount: 0,
                totalScenarioCount: 0,
                answeredCount: 0,
                pendingCount: 0,
                okCount: 0,
                koCount: 0,
                unableCount: 0,
                ratingAverage: null,
                smileyDominantLabelKey: null
            };
            var ratingSum = 0;
            var ratingCount = 0;
            var smileyCounts = {
                1: 0,
                2: 0,
                3: 0,
                4: 0
            };

            results.forEach(function(result) {
                var overallStatus = result && result.overallStatus ? result.overallStatus : 'NOT_STARTED';
                if (overallStatus === 'DONE') {
                    stats.completedCount++;
                } else if (overallStatus === 'IN_PROGRESS') {
                    stats.inProgressCount++;
                } else {
                    stats.notStartedCount++;
                }

                angular.forEach(result.scenarioResults || [], function(scenarioResult) {
                    var responseType = getScenarioResponseType(scenarioResult);
                    stats.totalScenarioCount++;

                    if (hasScenarioResponse(scenarioResult)) {
                        stats.answeredCount++;
                    } else {
                        stats.pendingCount++;
                    }

                    if (scenarioResult.status === 'OK') {
                        stats.okCount++;
                    } else if (scenarioResult.status === 'KO') {
                        stats.koCount++;
                    } else if (scenarioResult.status === 'UNABLE_TO_ANSWER') {
                        stats.unableCount++;
                    } else if (scenarioResult.status === 'ANSWERED' && responseType === 'RATING_10'
                        && scenarioResult.answerValue !== null && scenarioResult.answerValue !== undefined) {
                        ratingSum += Number(scenarioResult.answerValue);
                        ratingCount++;
                    } else if (scenarioResult.status === 'ANSWERED' && responseType === 'SMILEY_4'
                        && scenarioResult.answerValue !== null && scenarioResult.answerValue !== undefined) {
                        smileyCounts[scenarioResult.answerValue] = (smileyCounts[scenarioResult.answerValue] || 0) + 1;
                    }
                });
            });

            if (ratingCount > 0) {
                stats.ratingAverage = Math.round((ratingSum / ratingCount) * 10) / 10;
            }
            stats.smileyDominantLabelKey = resolveDominantSmileyLabelKey(smileyCounts);
            vm.planStats = stats;
        }

        function getScenarioDomainTitle(scenarioResult) {
            return getScenarioDefinition(scenarioResult).domainTitle || scenarioResult.domainId;
        }

        function getScenarioTitle(scenarioResult) {
            return getScenarioDefinition(scenarioResult).scenarioTitle || scenarioResult.scenarioId;
        }

        function getScenarioAnswerLabel(scenarioResult) {
            var responseType = getScenarioResponseType(scenarioResult);
            var status = scenarioResult && scenarioResult.status ? scenarioResult.status : 'NOT_TESTED';

            if (status === 'NOT_TESTED') {
                return $translate.instant('testPlan.runner.notTested');
            }
            if (status === 'UNABLE_TO_ANSWER') {
                return $translate.instant('testPlan.runner.unableToAnswer');
            }
            if (status === 'OK' || status === 'KO') {
                return status;
            }
            if (status === 'ANSWERED' && responseType === 'RATING_10') {
                return $translate.instant('testPlan.runner.ratingValue', { value: scenarioResult.answerValue });
            }
            if (status === 'ANSWERED' && responseType === 'SMILEY_4') {
                return $translate.instant(getSmileyLabelKey(scenarioResult.answerValue));
            }
            return status;
        }

        function getScenarioResponseTypeLabel(scenarioResult) {
            var responseType = getScenarioResponseType(scenarioResult);
            if (responseType === 'RATING_10') {
                return $translate.instant('testPlan.monitoring.responseTypeRating10');
            }
            if (responseType === 'SMILEY_4') {
                return $translate.instant('testPlan.monitoring.responseTypeSmiley4');
            }
            return $translate.instant('testPlan.monitoring.responseTypeStatus');
        }

        function getOverallStatusLabel(overallStatus) {
            if (overallStatus === 'DONE') {
                return $translate.instant('testPlan.monitoring.overallStatusDone');
            }
            if (overallStatus === 'IN_PROGRESS') {
                return $translate.instant('testPlan.monitoring.overallStatusInProgress');
            }
            return $translate.instant('testPlan.monitoring.overallStatusNotStarted');
        }

        function getResultProgressLabel(result) {
            var progress = getResultProgress(result);
            return progress.answered + ' / ' + progress.total;
        }

        function getAttachmentCount(scenarioResult) {
            return scenarioResult && scenarioResult.attachments ? scenarioResult.attachments.length : 0;
        }

        function getResultProgress(result) {
            var total = result && result.scenarioResults ? result.scenarioResults.length : 0;
            var answered = 0;

            angular.forEach(result && result.scenarioResults ? result.scenarioResults : [], function(scenarioResult) {
                if (hasScenarioResponse(scenarioResult)) {
                    answered++;
                }
            });

            return {
                answered: answered,
                total: total
            };
        }

        function hasScenarioResponse(scenarioResult) {
            return !!scenarioResult && !!scenarioResult.status && scenarioResult.status !== 'NOT_TESTED';
        }

        function getScenarioDefinition(scenarioResult) {
            if (!scenarioResult) {
                return {};
            }
            return vm.scenarioDefinitionsByKey[buildScenarioKey(scenarioResult.domainId, scenarioResult.scenarioId)] || {};
        }

        function getScenarioResponseType(scenarioResult) {
            return getScenarioDefinition(scenarioResult).responseType || 'STATUS';
        }

        function resolveDominantSmileyLabelKey(smileyCounts) {
            var dominantValue = null;
            var dominantCount = 0;

            angular.forEach(smileyCounts, function(count, value) {
                if (count > dominantCount) {
                    dominantCount = count;
                    dominantValue = Number(value);
                }
            });

            return dominantCount > 0 ? getSmileyLabelKey(dominantValue) : null;
        }

        function getSmileyLabelKey(value) {
            if (value === 1) {
                return 'testPlan.runner.smiley1';
            }
            if (value === 2) {
                return 'testPlan.runner.smiley2';
            }
            if (value === 3) {
                return 'testPlan.runner.smiley3';
            }
            return 'testPlan.runner.smiley4';
        }

        function buildScenarioKey(domainId, scenarioId) {
            return domainId + '::' + scenarioId;
        }

        function resolveErrorMessage(response, defaultMessage) {
            var headerDetail = readHeader(response, 'X-wamasysApp-detail');
            if (headerDetail) {
                return headerDetail;
            }
            if (response && response.data) {
                if (angular.isString(response.data)) {
                    return response.data;
                }
                if (response.data.message) {
                    return response.data.message;
                }
                if (response.data.error_description) {
                    return response.data.error_description;
                }
            }
            return defaultMessage;
        }

        function readHeader(response, headerName) {
            if (!response || !response.headers) {
                return null;
            }
            return response.headers(headerName) || response.headers(headerName.toLowerCase());
        }
    }
})();
